/**
 * Adds the event listeners to the contact form.
 */
export function addContactListeners() {
  const entries = [contact_name, contact_email, contact_message];

  // checks for change in input field
  entries.forEach(entry => {
    entry.addEventListener('change', () => {
      checkValue(entry)
    })
  });
  
  // checks if all input fields pass the requirements
  contact_btn.addEventListener('click', () => {
    if (checkFields(entries)) {
      sendEmail(entries, contact_btn)
    }
  })
}

/**
 * Checks if the entry value meets the requirements.
 * @param {HTMLElement} entry 
 * @returns {boolean}
 */
function checkValue(entry) {
  let pass = true;
  let message;
  const email_regex = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

  if (entry.type == 'text') {
    message = 'You need to provide a name.'
  } else if (entry.type == 'email') {
    message = 'You need to provide an email.'
  } else if (entry.type == 'textarea') {
    message = 'You need to provide a message.'
  }
  
  if (!entry.value) {
    pass = false;
    showFieldError(true, entry, message)
  } else {
    if (entry.type == 'email' && !email_regex.test(entry.value)) {
      pass = false;
      showFieldError(true, entry, 'You need to provide a proper email.')
    } else {
      showFieldError(false, entry)
    }
  }
  
  return pass
}

/**
 * Checks if all the input fields pass the requirement.
 * @param {Array.<HTMLElement>} entries 
 * @returns {boolean}
 */
function checkFields(entries) {
  let pass = true;

  entries.forEach(entry => {
    if (!checkValue(entry)) {
      pass = false
    }
  });
  
  return pass
}

/**
 * Shows an error message if the field value did not meet the requirements.
 * @param {boolean} remove 
 * @param {HTMLElement} entry 
 * @param {string} [message] 
 */
function showFieldError(remove, entry, message) {
  if (remove) {
    entry.nextElementSibling.style.display = 'initial';
    entry.nextElementSibling.innerText = message
  } else {
    entry.nextElementSibling.style.display = 'none'
  }
}

/**
 * Changes form state according to the phases of data submission.
 * @param {string} state 
 * @param {Array.<HTMLElement>} [entries]
 * @param {string} [errMessage]
 */
function changeFormState(state, entries, errMessage) {
  if (state == 'sending') {
    entries.forEach(entry => {
      entry.style = 'pointer-events:none;opacity:.5'
    });

    contact_btn.style = 'pointer-events:none;opacity:.5';
    contact_btn.innerText = 'sending...'
  } else if (state == 'success') {
    form_indicator.style.overflow = 'hidden';
    form_indicator.classList.add('success')
  } else if (state == 'error') {
    form_indicator.style.overflow = 'hidden';
    form_indicator.classList.add('error');
    form_indicator.children[1].children[1].innerHTML += `<br><br> You may as well send me this error<br><code>${errMessage}</code>` 
  }
}

/**
 * Creates a fake hidden form and uses it to send the data over to the email request.
 * @param {Array.<HTMLElement>} entries
 */
function sendEmail(entries) {
  changeFormState('sending', entries);

  const formdata = new FormData();
  formdata.append('name', entries[0].value);
  formdata.append('email', entries[1].value);
  formdata.append('message', entries[2].value);

  fetch("https://hook.eu1.make.com/1ydflxia4xwh5wxbovgkqxd2j1r134xr", {
    method: 'POST', body: formdata
  })
  .then(res => res.text())
  .then(res => {
    if (res == 'Accepted') {
      changeFormState('success')
    } else {
      changeFormState('error', null, res)
    }
  }).catch(err => {
    changeFormState('error', null, err)
  })
}